var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("toolbox.title_details") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner ? _c("spinner") : _vm._e(),
              _vm._v(" "),
              !_vm.activateSpinner
                ? [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-start" },
                      [
                        _c(
                          "b-col",
                          { attrs: { sm: "3", md: "2", xl: "2" } },
                          [
                            _c("back-button", {
                              attrs: { returnUrl: _vm.returnUrl },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "3", md: "4", xl: "2" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btnFilter",
                                on: { click: _vm.onRefresh },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-light fa-rotate-right fs-14px",
                                }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("common.rfrsh")) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            attrs: {
                              "offset-xl": "4",
                              sm: "3",
                              md: "4",
                              xl: "2",
                            },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btnFilter",
                                on: { click: _vm.onAddDataset },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-plus fs-14px",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("toolbox.add_dataset")) +
                                      " "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { sm: "3", md: "4", xl: "2" } },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mb-3 justify-item-end",
                                attrs: { variant: "primary" },
                                on: { click: _vm.trigOnImportCSV },
                              },
                              [
                                _c("i", { staticClass: "fa-light fa-plus " }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("toolbox.import_dataset"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              ref: "fileInput",
                              staticClass: "d-none",
                              attrs: { type: "file", accept: ".csv" },
                              on: { change: _vm.onImportCSV },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form-accordion",
                      {
                        staticClass: "mt-25px",
                        attrs: {
                          title: _vm.$t("toolbox.details"),
                          isTitleUpperCase: false,
                        },
                      },
                      [
                        _c(
                          "b-row",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { sm: "3", md: "3", xl: "2" },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("toolbox.last_test_date")) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                this.testCase.datelastExec.length === 0
                                  ? _c("p", { staticClass: "redFont" }, [
                                      _vm._v(
                                        "\n               " +
                                          _vm._s(
                                            _vm.$t("toolbox.never_tested")
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _c("p", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.date_format(
                                              this.testCase.datelastExec
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { sm: "3", md: "3", xl: "2" },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("toolbox.case_summary")) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(this.testCase.case_summary) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { sm: "3", md: "3", xl: "2" },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("toolbox.nb_req_res")) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(this.countSuccess()) +
                                      "/" +
                                      _vm._s(
                                        this.listDataset.filter(function (
                                          item
                                        ) {
                                          return item.isDefaultDataset === false
                                        }).length
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { sm: "3", md: "3", xl: "2" },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("toolbox.last_status")) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                [
                                  _c("p", [
                                    this.testCase.status === 2
                                      ? _c("i", {
                                          staticClass: "fas fa-check",
                                          staticStyle: {
                                            color: "white",
                                            "background-color": "green",
                                            "border-radius": "50%",
                                            padding: "5px",
                                            width: "20px",
                                            height: "20px",
                                            display: "inline-flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                          attrs: { title: "OK" },
                                        })
                                      : this.testCase.status === 0
                                      ? _c("i", {
                                          staticClass: "fas fa-multiply",
                                          staticStyle: {
                                            color: "white",
                                            "background-color": "red",
                                            "border-radius": "50%",
                                            padding: "5px",
                                            width: "20px",
                                            height: "20px",
                                            display: "inline-flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                          attrs: { title: "KO" },
                                        })
                                      : this.testCase.status === 1
                                      ? _c("i", {
                                          staticClass: "fas fa-hourglass-half",
                                          staticStyle: {
                                            color: "white",
                                            "background-color": "orange",
                                            "border-radius": "50%",
                                            padding: "5px",
                                            width: "20px",
                                            height: "20px",
                                            display: "inline-flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                          attrs: { title: "RUN" },
                                        })
                                      : this.testCase.status === 3
                                      ? _c("i", {
                                          staticClass: "fas fa-file-alt",
                                          staticStyle: {
                                            color: "gray",
                                            "font-size": "20px",
                                          },
                                          attrs: {
                                            title: "Missing configuration",
                                          },
                                        })
                                      : this.testCase.status === 4
                                      ? _c("i", {
                                          staticClass: "fas fa-hourglass-half",
                                          staticStyle: {
                                            color: "gray",
                                            "font-size": "20px",
                                          },
                                          attrs: { title: "Pending" },
                                        })
                                      : this.testCase.status === 5
                                      ? _c("i", {
                                          staticClass: "fas fa-minus",
                                          staticStyle: {
                                            color: "white",
                                            "background-color": "gray",
                                            "border-radius": "50%",
                                            padding: "5px",
                                            width: "20px",
                                            height: "20px",
                                            display: "inline-flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                          attrs: { title: "Never tested" },
                                        })
                                      : _vm._e(),
                                  ]),
                                ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-row",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "form-group",
                                attrs: { sm: "12" },
                              },
                              [
                                _c("label", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("toolbox.case_description")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "toolbox.req_description_case." +
                                            this.testCase.description_case
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("hr", { staticClass: "mx-auto mb-4" }),
                    _vm._v(" "),
                    _vm._l(_vm.listDataset, function (dataset, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "form-accordion",
                            {
                              attrs: {
                                title: _vm.title_dataset(dataset, index),
                                isTitleUpperCase: false,
                                open: dataset.isOpen,
                              },
                            },
                            [
                              _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t("toolbox.dataset_details"),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "form-group justify-content-start",
                                    },
                                    [
                                      !dataset.isDefaultDataset &&
                                      !dataset.isNew
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: {
                                                sm: "3",
                                                md: "4",
                                                xl: "3",
                                              },
                                            },
                                            [
                                              _c("label", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "toolbox.creation_date"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.date_format(
                                                        dataset.creation_date
                                                      )
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !dataset.isDefaultDataset &&
                                      !dataset.isNew
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "form-group",
                                              attrs: {
                                                sm: "3",
                                                md: "4",
                                                xl: "3",
                                              },
                                            },
                                            [
                                              !dataset.isDefaultDataset
                                                ? [
                                                    _c("label", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "toolbox.dataset_last_date_test"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    dataset.history.length === 0
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "redFont",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "toolbox.never_tested"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            ),
                                                          ]
                                                        )
                                                      : _c("p", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.date_format(
                                                                  dataset
                                                                    .history[0]
                                                                    .execution
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-row",
                                    { staticClass: "form-group" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "form-group",
                                          attrs: { xl: "6" },
                                        },
                                        [
                                          _c("form-write-group-label-input", {
                                            attrs: {
                                              maxLength: 512,
                                              inputLabel: _vm.$t(
                                                "toolbox.case_description"
                                              ),
                                              placeholderValue: _vm.$t(
                                                "toolbox.case_description"
                                              ),
                                            },
                                            model: {
                                              value: dataset.description_case,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  dataset,
                                                  "description_case",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dataset.description_case",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", {
                                        staticClass: "form-group",
                                        attrs: { sm: "0", md: "0", xl: "6" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "mx-auto" }),
                              _vm._v(" "),
                              dataset.request
                                ? _c(
                                    "form-accordion",
                                    {
                                      attrs: {
                                        title: _vm.$t("toolbox.data_request"),
                                        isTitleUpperCase: false,
                                      },
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass: "justify-content-start",
                                        },
                                        _vm._l(
                                          _vm.requirement_request,
                                          function (require, index) {
                                            return _c(
                                              "b-col",
                                              {
                                                key: index,
                                                attrs: { sm: "12", xl: "3" },
                                              },
                                              [
                                                _c(
                                                  "form-write-group-label-input",
                                                  {
                                                    staticClass: "mt-3",
                                                    attrs: {
                                                      disabled:
                                                        !require.editable,
                                                      maxLength: 512,
                                                      inputLabel:
                                                        _vm.$t(
                                                          "toolbox." +
                                                            _vm.split_form(
                                                              require.name
                                                            ).name
                                                        ) +
                                                        _vm.split_form(
                                                          require.name
                                                        ).number,
                                                      placeholderValue:
                                                        _vm.$t(
                                                          "toolbox." +
                                                            _vm.split_form(
                                                              require.name
                                                            ).name
                                                        ) +
                                                        _vm.split_form(
                                                          require.name
                                                        ).number,
                                                    },
                                                    model: {
                                                      value:
                                                        dataset.request[
                                                          require.name
                                                        ].value,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          dataset.request[
                                                            require.name
                                                          ],
                                                          "value",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataset.request[require.name].value",
                                                    },
                                                  },
                                                  [
                                                    dataset.request[
                                                      require.name
                                                    ].isEmpty ||
                                                    dataset.request[
                                                      require.name
                                                    ].regex_failed ||
                                                    dataset.request[
                                                      require.name
                                                    ].error
                                                      ? _c("i", {
                                                          staticClass:
                                                            "fas fa-multiply",
                                                          staticStyle: {
                                                            color: "white",
                                                            "background-color":
                                                              "red",
                                                            "border-radius":
                                                              "50%",
                                                            "margin-left":
                                                              "5px",
                                                            padding: "5px",
                                                            width: "20px",
                                                            height: "20px",
                                                            display:
                                                              "inline-flex",
                                                            "justify-content":
                                                              "center",
                                                            "align-items":
                                                              "center",
                                                          },
                                                          attrs: {
                                                            title: "OK",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("hr", { staticClass: "mx-auto mb-4" }),
                              _vm._v(" "),
                              _c(
                                "form-accordion",
                                {
                                  attrs: {
                                    title: _vm.$t("toolbox.response"),
                                    isTitleUpperCase: false,
                                  },
                                },
                                [
                                  _c(
                                    "b-row",
                                    { staticClass: "justify-content-start" },
                                    _vm._l(
                                      _vm.requirement_response,
                                      function (require, index) {
                                        return _c(
                                          "b-col",
                                          {
                                            key: index,
                                            attrs: { sm: "12", xl: "3" },
                                          },
                                          [
                                            _c(
                                              "form-write-group-label-input",
                                              {
                                                staticClass: "mt-3",
                                                attrs: {
                                                  disabled: !require.editable,
                                                  maxLength: 512,
                                                  inputLabel:
                                                    _vm.$t(
                                                      "toolbox." +
                                                        _vm.split_form(
                                                          require.name
                                                        ).name
                                                    ) +
                                                    _vm.split_form(require.name)
                                                      .number,
                                                  placeholderValue:
                                                    _vm.$t(
                                                      "toolbox." +
                                                        _vm.split_form(
                                                          require.name
                                                        ).name
                                                    ) +
                                                    _vm.split_form(require.name)
                                                      .number,
                                                },
                                                model: {
                                                  value:
                                                    dataset.response[
                                                      require.name
                                                    ]["value"],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      dataset.response[
                                                        require.name
                                                      ],
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataset.response[require.name]['value']",
                                                },
                                              },
                                              [
                                                dataset.response[require.name]
                                                  .isEmpty ||
                                                dataset.response[require.name]
                                                  .regex_failed ||
                                                dataset.response[require.name]
                                                  .error
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fas fa-multiply",
                                                      staticStyle: {
                                                        color: "white",
                                                        "background-color":
                                                          "red",
                                                        "border-radius": "50%",
                                                        "margin-left": "5px",
                                                        padding: "5px",
                                                        width: "20px",
                                                        height: "20px",
                                                        display: "inline-flex",
                                                        "justify-content":
                                                          "center",
                                                        "align-items": "center",
                                                      },
                                                      attrs: { title: "OK" },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "mx-auto mb-4" }),
                              _vm._v(" "),
                              dataset.history.length > 0
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "form-accordion",
                                        {
                                          attrs: {
                                            title: _vm.$t("toolbox.history"),
                                            isTitleUpperCase: false,
                                          },
                                        },
                                        [
                                          _c("b-table", {
                                            staticClass: "table table-striped",
                                            staticStyle: {
                                              "margin-bottom": "0",
                                            },
                                            attrs: {
                                              hover: "",
                                              fields: _vm.fields,
                                              items: dataset.history,
                                              "empty-text": _vm.$t(
                                                "common.security.no_result"
                                              ),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "cell(status)",
                                                  fn: function (data) {
                                                    return [
                                                      data.value === "2"
                                                        ? _c("div", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-check",
                                                              staticStyle: {
                                                                color: "white",
                                                                "background-color":
                                                                  "green",
                                                                "border-radius":
                                                                  "50%",
                                                                padding: "5px",
                                                                width: "20px",
                                                                height: "20px",
                                                                display:
                                                                  "inline-flex",
                                                                "justify-content":
                                                                  "center",
                                                                "align-items":
                                                                  "center",
                                                              },
                                                              attrs: {
                                                                title: "OK",
                                                              },
                                                            }),
                                                          ])
                                                        : data.value === "0"
                                                        ? _c("div", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-multiply",
                                                              staticStyle: {
                                                                color: "white",
                                                                "background-color":
                                                                  "red",
                                                                "border-radius":
                                                                  "50%",
                                                                padding: "5px",
                                                                width: "20px",
                                                                height: "20px",
                                                                display:
                                                                  "inline-flex",
                                                                "justify-content":
                                                                  "center",
                                                                "align-items":
                                                                  "center",
                                                              },
                                                              attrs: {
                                                                title: "KO",
                                                              },
                                                            }),
                                                          ])
                                                        : data.value === "1"
                                                        ? _c("div", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-hourglass-half",
                                                              staticStyle: {
                                                                color: "white",
                                                                "background-color":
                                                                  "orange",
                                                                "border-radius":
                                                                  "50%",
                                                                padding: "5px",
                                                                width: "20px",
                                                                height: "20px",
                                                                display:
                                                                  "inline-flex",
                                                                "justify-content":
                                                                  "center",
                                                                "align-items":
                                                                  "center",
                                                              },
                                                              attrs: {
                                                                title: "RUN",
                                                              },
                                                            }),
                                                          ])
                                                        : data.value === "3"
                                                        ? _c("div", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-file-alt",
                                                              staticStyle: {
                                                                color: "gray",
                                                                "font-size":
                                                                  "20px",
                                                              },
                                                              attrs: {
                                                                title:
                                                                  "Missing configuration",
                                                              },
                                                            }),
                                                          ])
                                                        : data.value === "4"
                                                        ? _c("div", [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-hourglass-half",
                                                              staticStyle: {
                                                                color: "gray",
                                                                "font-size":
                                                                  "20px",
                                                              },
                                                              attrs: {
                                                                title:
                                                                  "Pending",
                                                              },
                                                            }),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("hr", { staticClass: "mx-auto mb-4" }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                { staticClass: "justify-content-center" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center",
                                      attrs: { cols: "3" },
                                    },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.action_save(index + 1)
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("toolbox.save_data")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !dataset.isDefaultDataset && !dataset.isNew
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteDataset(
                                                    index + 1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "toolbox.delete_data"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !dataset.isDefaultDataset && !dataset.isNew
                                ? _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "justify-content-center pt-10px",
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                        },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              staticClass: "p-1",
                                              attrs: { variant: "danger" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.failed_dataset(
                                                    index + 1
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-light fa-times",
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "toolbox.failed_dataset"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "mx-auto mb-4" }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    this.listDataset.filter(function (item) {
                      return (
                        item.isDefaultDataset === false || item.isNew === true
                      )
                    }).length > 0
                      ? _c(
                          "b-row",
                          { staticClass: "justify-content-center" },
                          [
                            _c(
                              "b-col",
                              { staticClass: "d-flex justify-content-center" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "p-1",
                                    attrs: { variant: "danger" },
                                    on: { click: _vm.failed_testcase },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-times",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("toolbox.failed_testcase")
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }